<script>
import { defineComponent } from "vue";
import customerQuoteItem from '@/components/customer/quotes/quoteItem.vue';
import { useMeta } from 'quasar';
import EmailQuoteModal from '@/components/customer/quotes/emailQuoteModal.vue';
import QuoteToOrderModal from '@/components/customer/quotes/quoteToOrderModal.vue';

const metaData = {
  // sets document title
  title: 'Windy City Wire - Quotes',
  // optional; sets final title as "Index Page - My Website", useful for multiple level meta
  titleTemplate: title => `${title}`,
}

export default defineComponent({
  name: "customerQuotes",
  setup() {
    useMeta(metaData);
  },
  components: {
    customerQuoteItem,
    EmailQuoteModal,
    QuoteToOrderModal
  },
  computed: {
      accessToken() {
          return this.$store.getters['auth/accessToken'];
      },
      height() {
          return this.$store.getters['viewHeight']
      },
      emailQuote() {
          return this.$store.getters['customer/emailQuote'];
      },
      isProcessingOrder() {
          return this.$store.getters['customer/isProcessingOrder'];
      },
      quotes() {
        return this.$store.getters['customer/quotes'];
      }
  },
  methods: {
      fetchShipTos() {
          this.$store.dispatch('customer/getShipTos', this.accessToken)
      },
      fetchQuotes() {
        this.$store.dispatch('customer/getQuotes', this.accessToken);
      },
  },
  mounted() {
      this.fetchQuotes();
      this.fetchShipTos();
  }
});
</script>


<template>
  <div class="scroll" height="100vh">

    <q-list bordered v-if="quotes.length>0">
            <q-scroll-area v-bind:style="{height: '100vh', maxWidth: '100%', paddingBottom: '50px'}" ref="scrollTarget">
                <customer-quote-item v-for="(q, idx) in quotes" :key="idx" :quote=q></customer-quote-item>
                <div class="mobileDiv"></div>
                <div class="spacerBottom"></div>
            </q-scroll-area>
    </q-list>

    <div class="q-mt-xl text-center" v-if="quotes.length==0&&!isProcessingOrder">
        <h6>No Quotes</h6>
    </div>

    <q-inner-loading
    :showing="isProcessingOrder"
    label="Please wait loading data..."
    label-class="text-cyan-7"
    label-style="font-size: 1.5em"
    color="cyan-7"
    />


      <!-- MODALS -->
      <email-quote-modal :emailQuote=emailQuote></email-quote-modal>
      <quote-to-order-modal></quote-to-order-modal>  

  </div>
</template>